<app-base-action-modal
  modalTitle="Add Additional Contact"
  i18n-modalTitle
  primaryLabel="Add Contact"
  i18n-primaryLabel
  secondaryLabel="Cancel"
  i18n-secondaryLabel
  (closeClicked)="cancel()"
  (secondaryClicked)="cancel()"
  (primaryClicked)="addContact()">
  <app-employer-additional-contact-form-grid
    [form]="formGroup"
    [formSubmitted]="formSubmitted"
    [countryCodeDropdowns]="(countryCodeDropdowns$ | async) ?? []"
    controlIdPrefix="add-additional-contact-modal-" />
</app-base-action-modal>
